import { LocaleConfig } from '@lockton-apps/shared/util/localization';

export interface DynamicFormsLocaleConfig {
  dateMask: string;
  datePlaceholder: string;
}

export function dynamicFormsLocaleFactory(
  localConfig: LocaleConfig
): DynamicFormsLocaleConfig {
  const { datePlaceholder, dateMask } = localConfig;
  return {
    dateMask,
    datePlaceholder,
  };
}
